<template>
  <div>
    <el-table :data="data" border height="100%" style="width: 100%">
      <el-table-column prop="id" label="任务号" width="80">
      </el-table-column>
      <el-table-column prop="command" label="操作" width="80">
      </el-table-column>
      <el-table-column prop="recording_length" label="录音时长(秒)" width="110">
        <template slot-scope="scope">
          {{scope.row.recording_length?scope.row.recording_length:"-"}}
        </template>
      </el-table-column>
      <el-table-column label="扫描频率" width="110">
        <template slot-scope="scope">
          {{scope.row.freq_range?scope.row.freq_range:"-"}}
        </template>
      </el-table-column>
      <el-table-column prop="detail" label="任务说明">
      </el-table-column>
      <el-table-column prop="start_time" label="开始时间" width="160">
      </el-table-column>
      <el-table-column prop="finish_time" label="完成时间" width="160">
      </el-table-column>
    </el-table>
    <Pagination totalCountOrURL="/terminal/cnt_realtimeTaskRd" :params="{device_lgid:lgid}" @change="handlePageChange"></Pagination>
  </div>
</template>

<script>
  import Pagination from "@/components/PageNations/Pagination";
  export default {
    props: ["lgid"],
    components: {
      Pagination
    },
    mounted() {
      this.getData();
    },
    watch: {
      lgid() {
        this.getData();
      }
    },
    data() {
      return {
        selected_idx: "",
        whiteListVisible: false,
        data: [],
        page: 1,
        size: 10
      };
    },
    methods: {
      handlePageChange(params) {
        this.page = params.page;
        this.size = params.size;
        this.getData();
      },
      getData() {
        if (this.lgid) {
          this.$getJSON("/terminal/s_realtimeTaskRd", {
            device_lgid: this.lgid,
            page: this.page,
            size: this.size
          }).then(res => {
            this.data = res.data;
          });
        }
      }
    }
  };

</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/Tables/RealtimeTaskRd.vue